import React from 'react';
import Config from './config';

const BetaBanner = () => {
    if (!Config.beta) return null;

    return (
        <div style={{
            background: '#f59e0b',
            color: '#1c1917',
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: '0.85rem',
            letterSpacing: '0.08em',
            padding: '6px 0',
            width: '100%',
            position: 'sticky',
            top: 0,
            zIndex: 9999,
        }}>
            VERSÃO BETA — ambiente de testes
        </div>
    );
};

export default BetaBanner;
